module.exports = __webpack_public_path__ + "static/img/14bg_6.f78deb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_6.png
// module id = 657
// module chunks = 1